(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ipg-art-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ipg-art-picker')) {
    customElements.define('ipg-art-picker', class extends HTMLElement {
      connectedCallback() {
        if (this._connectionScheduled) return;
        this._connectionScheduled = true;
        this._readyHandler = () => {
          this._readyHandler = null;
          if (this.isConnected) this.initialize();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._readyHandler, { once: true });
        } else {
          queueMicrotask(this._readyHandler);
        }
      }
      initialize() {
        if (this._section) return;
        const section = this.closest('.product__item-js');
        const picker = this.querySelector('variant-radios-detail, variant-group-detail');
        const status = this.querySelector('.ipg-art-picker__status');
        if (!section || !picker || !status || !picker.querySelector('script[type="application/json"]')) return;
        this._section = section;
        this._formIds = [this.dataset.formId, this.dataset.formId.replace(/^product-form-/, 'sticky-addcart-form-')];
        this._picker = this.querySelector('variant-radios-detail, variant-group-detail');
        this._status = this.querySelector('.ipg-art-picker__status');
        this._paymentStates = new Map();
        if (!this._section || !this._picker) return;
        this._onChange = this.onChange.bind(this);
        this._onSizeSelection = this.onSizeSelection.bind(this);
        this._onSubmit = this.onSubmit.bind(this);
        this._onClick = this.onClick.bind(this);
        this._onKeydown = this.onKeydown.bind(this);
        this._section.addEventListener('change', this._onChange);
        this._section.addEventListener('submit', this._onSubmit, true);
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onSizeSelection, true);
        this.addEventListener('keydown', this._onKeydown);
        this._observer = new MutationObserver(() => this.syncExpanded());
        this.querySelectorAll('swatch-dropdown').forEach(dropdown => this._observer.observe(dropdown, { attributes: true, attributeFilter: ['class'] }));
        const form = document.getElementById(this.dataset.formId);
        const initialId = form?.querySelector('input[name="id"]')?.value || this.dataset.initialVariantId;
        const data = JSON.parse(this._picker.querySelector('script[type="application/json"]').textContent);
        this.updateAvailability(data.find(variant => String(variant.id) === String(initialId)));
        this.syncOptionLabels();
        this.syncExpanded();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._readyHandler);
        this._readyHandler = null;
        this._connectionScheduled = false;
        this._section?.removeEventListener('change', this._onChange);
        this._section?.removeEventListener('submit', this._onSubmit, true);
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onSizeSelection, true);
        this.removeEventListener('keydown', this._onKeydown);
        this._observer?.disconnect();
        cancelAnimationFrame(this._sizeScrollFrame);
        this._paymentStates?.forEach((value, element) => { element.inert = value; });
        this.forms().forEach(form => form.removeAttribute('data-ipg-art-unavailable'));
        this._section = null;
      }
      onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
        const nativePicker = input.closest('variant-radios-detail, variant-group-detail, variant-radios-sticky, variant-group-sticky');
        if (!nativePicker || nativePicker.closest('.product__item-js') !== this._section) return;
        if (input instanceof HTMLInputElement && input.type !== 'radio') return;
        this.updateAvailability(nativePicker.currentVariant);
        this.syncOptionLabels();
        const dropdown = input.closest('swatch-dropdown');
        if (dropdown && this.contains(dropdown)) {
          dropdown.classList.remove('active');
          dropdown.querySelector('button')?.focus({ preventScroll: true });
        }
        this.syncExpanded();
      }
      onSizeSelection(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
        const dropdown = input.closest('.ipg-art-picker__size swatch-dropdown');
        if (dropdown && this.contains(dropdown) && dropdown.classList.contains('active') &&
          this.closest('.ipg-product-page, .product-quickview__content')) {
          this.restoreSizeSelectionView(dropdown);
        }
      }
      restoreSizeSelectionView(dropdown) {
        cancelAnimationFrame(this._sizeScrollFrame);
        this._sizeScrollFrame = requestAnimationFrame(() => {
          this._sizeScrollFrame = requestAnimationFrame(() => {
            if (!this.isConnected || !dropdown.isConnected || dropdown.classList.contains('active')) return;
            const toggle = dropdown.querySelector('button');
            if (!toggle) return;
            const documentScroller = document.scrollingElement || document.documentElement;
            let scroller = dropdown.parentElement;
            while (scroller && scroller !== document.body && scroller !== document.documentElement) {
              const style = getComputedStyle(scroller);
              if (/(auto|scroll|overlay)/.test(style.overflowY) && scroller.scrollHeight > scroller.clientHeight + 1) break;
              scroller = scroller.parentElement;
            }
            const inPage = !scroller || scroller === document.body || scroller === document.documentElement;
            if (inPage) scroller = documentScroller;
            const bounds = inPage ? { top: 0, bottom: window.innerHeight } : scroller.getBoundingClientRect();
            let top = bounds.top + (inPage ? 0 : scroller.clientTop) + 12;
            const bottom = inPage ? bounds.bottom - 12 : bounds.top + scroller.clientTop + scroller.clientHeight - 12;
            if (inPage) {
              document.querySelectorAll('.section-header, header-inner, sticky-header').forEach(header => {
                const position = getComputedStyle(header).position;
                const rect = header.getBoundingClientRect();
                if ((position === 'fixed' || position === 'sticky') && rect.top <= top && rect.height > 0 && rect.height < window.innerHeight / 2) {
                  top = Math.max(top, Math.max(rect.bottom, rect.height) + 12);
                }
              });
            }
            const rect = toggle.getBoundingClientRect();
            if (rect.top >= top && rect.bottom <= bottom) return;
            const heading = dropdown.closest('.ipg-art-picker__size')?.querySelector('.ipg-art-picker__heading');
            const anchor = heading || toggle;
            scroller.scrollTo({ top: Math.max(0, scroller.scrollTop + anchor.getBoundingClientRect().top - top), behavior: 'instant' });
          });
        });
      }
      updateAvailability(variant) {
        this._purchasable = Boolean(variant?.available);
        const forms = this.forms();
        forms.forEach(form => {
          form.toggleAttribute('data-ipg-art-unavailable', !this._purchasable);
          const input = form.querySelector('input[name="id"]');
          if (input) input.disabled = !this._purchasable;
          if (!this._purchasable) form.querySelectorAll('[type="submit"]').forEach(button => { button.disabled = true; });
        });
        forms.flatMap(form => [...form.querySelectorAll('.btn-checkout-dynamic, .shopify-payment-button')]).forEach(element => {
          if (!this._purchasable) {
            if (!this._paymentStates.has(element)) this._paymentStates.set(element, element.inert);
            element.inert = true;
          } else if (this._paymentStates.has(element)) {
            element.inert = this._paymentStates.get(element);
            this._paymentStates.delete(element);
          }
        });
        this._status.hidden = this._purchasable;
        this._status.textContent = this._purchasable ? '' : variant ? this.dataset.soldOut : this.dataset.unavailable;
      }
      onSubmit(event) {
        if (this._purchasable || !this._formIds.includes(event.target.getAttribute('id'))) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('input:checked')?.focus({ preventScroll: true });
      }
      onClick(event) {
        if (event.target.closest('.ipg-art-picker__toggle')) this.syncExpanded();
      }
      onKeydown(event) {
        const dropdown = event.target.closest('swatch-dropdown');
        if (!dropdown) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          dropdown.classList.remove('active');
          this.syncExpanded();
          dropdown.querySelector('button')?.focus({ preventScroll: true });
        } else if (['ArrowDown', 'ArrowUp'].includes(event.key) && event.target.closest('.ipg-art-picker__toggle')) {
          event.preventDefault();
          dropdown.classList.add('active');
          this.syncExpanded();
          dropdown.querySelector('input:checked')?.focus({ preventScroll: true });
        }
      }
      syncExpanded() {
        this.querySelectorAll('swatch-dropdown').forEach(dropdown => {
          dropdown.querySelector('button')?.setAttribute('aria-expanded', String(dropdown.classList.contains('active')));
        });
      }
      forms() {
        return (this._formIds || []).map(id => document.getElementById(id)).filter(form => form && this._section?.contains(form));
      }
      syncOptionLabels() {
        this._picker.querySelectorAll('fieldset').forEach(fieldset => {
          const input = fieldset.querySelector('input:checked');
          if (input) fieldset.querySelectorAll('.option_value').forEach(label => { label.textContent = input.value; });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
